import React from 'react';
import { BookOpen, Brain, Clock } from 'lucide-react';
import { Button, PriceDisplay } from './ui';
export const WhatYouGet = () => {
  return <section className="py-10 md:py-20 px-4 bg-brand-cream" data-id="element-339">
      <div className="max-w-5xl mx-auto" data-id="element-340">
        <div className="text-center mb-8 md:mb-16" data-id="element-341">
          <p className="text-brand-coral font-bold tracking-widest uppercase mb-4" data-id="element-342">
            La Solución Que Funciona Cuando Todo Lo Demás Falló
          </p>
          <h2 className="font-nunito font-extrabold text-4xl md:text-5xl text-brand-charcoal mb-4 leading-tight" data-id="element-343">
            "CÓMO AYUDAR A TU HIJO <br className="hidden md:block" data-id="element-344" />
            <span className="text-brand-teal" data-id="element-345">CON LA CONSTIPACIÓN"</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-medium" data-id="element-346">
            La guía que transforma la batalla del baño en un{' '}
            <strong data-id="element-347">proceso natural, tranquilo y sin llanto</strong>.
            <br data-id="element-348" />
            <span className="text-brand-charcoal italic mt-4 block" data-id="element-349">
              ...incluso si ya probaste todo y creés que no tiene solución.
            </span>
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100" data-id="element-350">
          <div className="bg-brand-teal text-white text-center py-4" data-id="element-351">
            <h3 className="font-nunito font-bold text-2xl" data-id="element-352">Qué incluye</h3>
          </div>

          <div className="p-5 md:p-12 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-12" data-id="element-353">
            <div className="flex flex-col items-center text-center space-y-4" data-id="element-354">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-brand-teal/10 rounded-2xl flex items-center justify-center text-brand-teal mb-1" data-id="element-355">
                <span className="font-nunito font-black text-2xl md:text-3xl" data-id="element-356">
                  1
                </span>
              </div>
              <h4 className="font-nunito font-bold text-xl text-brand-charcoal" data-id="element-357">
                Plan claro de acción inmediata
              </h4>
              <p className="text-gray-600" data-id="element-358">
                Sabés <strong data-id="element-359">exactamente qué hacer</strong> hoy, mañana y esta
                semana.{' '}
                <em data-id="element-360">Sin adivinar. Sin improvisar a las 7 de la noche.</em>
              </p>
            </div>

            <div className="flex flex-col items-center text-center space-y-4" data-id="element-361">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-brand-teal/10 rounded-2xl flex items-center justify-center text-brand-teal mb-1" data-id="element-362">
                <span className="font-nunito font-black text-2xl md:text-3xl" data-id="element-363">
                  2
                </span>
              </div>
              <h4 className="font-nunito font-bold text-xl text-brand-charcoal" data-id="element-364">
                Neurología del desarrollo explicada para mamás
              </h4>
              <p className="text-gray-600" data-id="element-365">
                Entendés <strong data-id="element-366">por qué retiene</strong> aunque quiera ir — y
                cómo{' '}
                <span className="underline decoration-gray-300 decoration-2 underline-offset-2" data-id="element-367">
                  romper el ciclo miedo-retención-más dolor
                </span>{' '}
                desde casa.
              </p>
            </div>

            <div className="flex flex-col items-center text-center space-y-4" data-id="element-368">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-brand-teal/10 rounded-2xl flex items-center justify-center text-brand-teal mb-1" data-id="element-369">
                <span className="font-nunito font-black text-2xl md:text-3xl" data-id="element-370">
                  3
                </span>
              </div>
              <h4 className="font-nunito font-bold text-xl text-brand-charcoal" data-id="element-371">
                Rápida y fácil de leer
              </h4>
              <p className="text-gray-600" data-id="element-372">
                Diseñada para <strong data-id="element-373">mamás sin tiempo</strong>. La leés en una
                siesta y ya tenés <em data-id="element-374">el plan en la mano</em>.
              </p>
            </div>
          </div>

          <div className="bg-gray-50 border-t border-gray-100 p-5 md:p-8 text-center" data-id="element-375">
            <div className="flex flex-col items-center justify-center space-y-2 mb-4" data-id="element-376">
              <p className="text-gray-500 line-through text-lg" data-id="element-377">
                Valor real: <PriceDisplay amount="40.000" data-id="element-378" />
              </p>
              <p className="font-nunito font-black text-5xl text-brand-coral" data-id="element-379">
                <PriceDisplay amount="18.999" data-id="element-380" />
              </p>
              <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mt-2" data-id="element-381">
                Pago único — Sin cuotas ocultas — Acceso inmediato
              </p>
            </div>

            <Button className="text-xl py-4 px-8 md:py-5 md:px-10" data-id="element-382">
              ✅ Quiero El Plan Completo + 4 Bonos Gratis →
            </Button>
          </div>
        </div>
      </div>
    </section>;
};